// ╔══════════════════════════════════════════════════════════════════════════════════╗
// ║  PRODUCTION DEPLOYMENT CONFIG                                                      ║
// ║  Uses runtime config (public/config.js) which is always hardcoded to production    ║
// ╚══════════════════════════════════════════════════════════════════════════════════╝

const BACKEND_URL = (window.RUNTIME_CONFIG && window.RUNTIME_CONFIG.BACKEND_URL) || 'https://tradeblindfolded.com';

export { BACKEND_URL };
export default () => BACKEND_URL;
